module.exports = __webpack_public_path__ + "img/2_44.ad7d7a7c.png";